// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { Portfolios } = require('../utilities/RAPortfolioHelper');
const { RA_UNDEFINED } = require('../raConstants/index');

const initialState = Immutable.fromJS({
    accountNumber: RA_UNDEFINED,
    accountAlias: '',
    accountHolder: '',
    cgdNumber: '',
    cgdHolderName: RA_UNDEFINED,
    isFetching: true,
    error: '',
    portfolioDetails: {
        portfolioName: '',
        portfolioType: '',
    },
    objectiveDetails: {
        objectiveName: '',
        portfolioName: '',
    },
    portfolioHistory: [],
    isPortfolioHistoryfetching: false,
    isHistoryFetchingError: false,
});

const dateSortedData = data => {
    data.sort(
        (item1, item2) =>
            new Date(item2['timestamp']) - new Date(item1['timestamp']),
    );
    return data;
};

const RAAccountDetails = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_GET_ACCOUNT_DETAILS_REQUEST:
            return state.merge({ isFetching: true, error: null });
        case actionTypes.RA_OBJECTIVE_DETAILS_SET_PORTFOLIO_DATA:
            const portfolioInfo =
                Portfolios[action.payload.data.product.typeOfProduct];
            return state.mergeIn(['objectiveDetails'], {
                objectiveName: action.payload.data.goalInformation
                    ? action.payload.data.goalInformation.name
                    : action.payload.data.name,
                portfolioName: portfolioInfo['portfolioName'],
            });
        case actionTypes.RA_GET_ACCOUNT_DETAILS_SUCCESS:
            const {
                cgdIban,
                accountIban,
                frequencyCode,
                accountAlias,
            } = action.payload.data;
            return state.merge({
                isFetching: false,
                error: null,
                cgdNumber: cgdIban,
                accountNumber: accountIban,
                accountAlias: accountAlias,
                cgdHolderName: frequencyCode,
            });
        case actionTypes.RA_GET_ACCOUNT_DETAILS_FAILURE:
            return state.merge({ error: true });
        case actionTypes.RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_DATA:
            return state.mergeIn(['portfolioDetails'], {
                portfolioName: action.payload.data.name,
                portfolioType: action.payload.data.product.typeOfProduct,
            });
        case actionTypes.RA_PORTFOLIO_HISTORY_REQUEST:
            return state.merge({ isPortfolioHistoryfetching: true });
        case actionTypes.RA_PORTFOLIO_HISTORY_REQUEST_SUCCESS:
            return state.merge({
                portfolioHistory: dateSortedData(action.payload.data),
                isPortfolioHistoryfetching: false,
                isHistoryFetchingError: false,
            });
        case actionTypes.RA_PORTFOLIO_HISTORY_REQUEST_FAILURE:
            return state.merge({
                isHistoryFetchingError: true,
                isPortfolioHistoryfetching: false,
            });
        default:
            return state;
    }
};

module.exports = RAAccountDetails;
